import { render, staticRenderFns } from "./Flexbox.vue?vue&type=template&id=a8899ffe"
import script from "./Flexbox.vue?vue&type=script&lang=js"
export * from "./Flexbox.vue?vue&type=script&lang=js"
import style0 from "./Flexbox.vue?vue&type=style&index=0&id=a8899ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports